module.exports = "../fonts/Futura-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./@fonts/futura/Futura-Medium.woff2
// module id = 513
// module chunks = 7